<template>
    <div class="datepicker"
        :class="{
            'input-field--readonly':    readonly,
            'input-field--disabled':    disabled,
            'input-field--vertical':    vertical,
            'input-field--stretch':     stretch,
            'input-field--spacing-off': spacingOff,
            'input-field--text-group':  textGroup
        }">
        <input @keyup="$emit('keyup')" :name="name" :disabled="disabled" :placeholder="dateFormat" @input="input" class="datepicker__input" v-mask="format" v-model="modelValue" type="tel"/>
    </div>
</template>

<script>
export default {
    props: {
        value: {
            default: ''
        },
        type: {
            type: String,
            default: 'date',
            required: false
        },
        id: {
            type: String,
            required: true
        },
        placeholder: {
            type: String,
            required: false
        },
        readonly: {
            type: Boolean,
            required: false
        },
        disabled: {
            type: Boolean,
            required: false
        },
        stretch: {
            type: Boolean,
            required: false
        },
        spacingOff: {
            type: Boolean,
            required: false
        },
        textGroup: {
            type: Boolean,
            required: false
        },
        vertical: {
            type: Boolean,
            required: false
        },
        name: {
            type: String,
            required: false,
            default: ''
        }
    },
    data: function () {
        return {
            modelValue: null
        };
    },
    computed: {
        format: function () {
            return this.type === 'date' ? '####-##-##' : '####-##-## ##:##';
        },
        dateFormat: function () {
            return this.type === 'date' ? 'YYYY-MM-DD' : 'YYYY-MM-DD HH:mm';
        }
    },
    mounted: function () {
        let date = this.value;
        this.modelValue = (date instanceof Date) ? moment(date).format(this.dateFormat) : date;
    },
    watch: {
        value: function (value) {
            this.modelValue = (value instanceof Date) ? moment(value).format(this.dateFormat) : value;
        }
    },
    methods: {
        input: function () {
            this.$emit('input', this.modelValue);
        }
    }
}
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/element/DatePicker.vue